import { useCallback } from 'react';
import { useLazyQuery } from '@apollo/react-hooks';

import { useSessionData } from '@confluence/session-data';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition';
import { useIsAllowedToCreateWhiteboard } from '@confluence/content-types-utils';

import { WhiteboardCreationPaywallContentToDisableQuery } from '../queries/WhiteboardCreationPaywallContentToDisableQuery.graphql';

type UsePreloadCreationMenuDataResponse = () => void;
export const usePreloadCreationMenuData = (): UsePreloadCreationMenuDataResponse => {
	const { edition } = useSessionData();
	const isPremium = edition === ConfluenceEdition.PREMIUM;

	const isAllowedToCreateWhiteboard = useIsAllowedToCreateWhiteboard();

	const [preloadWhiteboardPaywallData] = useLazyQuery(
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
		WhiteboardCreationPaywallContentToDisableQuery,
	);

	const shouldPreloadPaywallData = isAllowedToCreateWhiteboard && !isPremium;
	return useCallback(() => {
		if (shouldPreloadPaywallData) {
			preloadWhiteboardPaywallData();
		}
	}, [preloadWhiteboardPaywallData, shouldPreloadPaywallData]);
};
